import { Box } from "@mui/material"
import styles from "./index.module.css"

export default function DotStretchLoading() {
  return (
    <Box className={styles.flashing} />
  )
}